import { render, staticRenderFns } from "./KeyboardDigital.vue?vue&type=template&id=60d8b67d&scoped=true"
import script from "./KeyboardDigital.vue?vue&type=script&lang=js"
export * from "./KeyboardDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8b67d",
  null
  
)

export default component.exports